module.exports = __webpack_public_path__ + "img/yingxiao03.956dcd31.png";